import { useNavigate } from "react-router-dom";
import { ReactComponent as AcedImg } from "../../assets/images/AcedWhite.svg";
import { ReactComponent as Trophy } from "../../assets/images/Trophy.svg";
import Button from "../../components/essentials/button/Button";
import "./PaymentResult.scss";

const PaymentSuccess: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="payment-result">
			<AcedImg />
			<div className="payment-result__captions">
				<Trophy className="payment-result__icon" />
				<p className="payment-result__captions-title">Payment Successful!</p>
				<p className="payment-result__captions-subtitle">
					Your subscription has been upgraded successfully.
				</p>
			</div>

			<Button
				className="btn btn-primary"
				action={() => navigate("/board")}
			>
				Go to Dashboard
			</Button>
		</div>
	);
};

export default PaymentSuccess;
